<template>
  <UiPopoverDrawer
    v-model="isPopoverOpen"
    :classes="{
      popover: {
        body: ['min-w-[340px] max-w-[340px] overflow-hidden rounded-xl leading-tight', props.class],
      },
    }"
  >
    <template #trigger>
      <UiButton
        class="hover:bg-theme-foreground hover:text-theme h-10 w-10 rounded-full border"
        variant="icon"
      >
        <LucideBug class="size-4" />
      </UiButton>
    </template>

    <ConfigProvider>
      <div class="flex flex-col gap-4 md:pt-6">
        <span class="text-lg font-semibold">Debug Menu</span>

        <div class="flex flex-col gap-2" v-if="!isAuthenticated">
          <UiLabel class="text-sm">Login</UiLabel>

          <UiButton class="h-8 rounded-md text-sm" variant="outline" @click="login.open">Login</UiButton>
        </div>

        <div class="flex flex-col gap-2">
          <UiLabel class="text-sm">סטייג׳</UiLabel>

          <UiSelect
            :model-value="String(currentStage)"
            :disabled="flowStageManager.updateStageMutation.isPending"
            @update:model-value="flowStageManager.updateStageMutation.mutate({ currentStage: $event })"
          >
            <UiSelectTrigger class="h-8">
              <UiSelectValue class="flex items-center gap-2" placeholder="Select stage">
                <span>{{ currentStage }}</span>
                <UiTransition>
                  <UiSpinner class="size-3" v-if="flowStageManager.updateStageMutation.isPending" />
                </UiTransition>
              </UiSelectValue>
            </UiSelectTrigger>

            <UiSelectContent>
              <UiSelectItem :value="(null as any)">Null</UiSelectItem>
              <UiSelectItem v-for="stageKey in FlowStage.StageKey" :value="stageKey">{{
                stageKey
              }}</UiSelectItem>
            </UiSelectContent>
          </UiSelect>
        </div>

        <div
          class="flex cursor-pointer items-center justify-between gap-2"
          @click="debugStore.mockCategories = !debugStore.mockCategories"
        >
          <UiLabel
            :class="
              cn('hover:text-primary cursor-pointer text-sm', { 'text-primary': debugStore.mockCategories })
            "
            >מוק קטגוריות</UiLabel
          >
          <UiSwitch class="pointer-events-none" :model-value="debugStore.mockCategories" size="small" />
        </div>

        <div class="gap-inherit mt-2 flex flex-wrap items-center">
          <UiButton class="h-8 gap-2 rounded-md text-sm" variant="outline" @click="copyUserDetails">
            <LucideCopy class="size-4" /> Copy User Details
          </UiButton>
        </div>
      </div>
    </ConfigProvider>
  </UiPopoverDrawer>
</template>

<script setup lang="tsx">
import { LucideBug, LucideCopy } from "lucide-vue-next"
import { ConfigProvider } from "reka-ui"

import { FlowStage } from "@finq/app-base/types/flowStage.namespace"

// const lastSelectedPage = useSessionStorage("kyc-last-selected-page", "LOBBY")

const props = defineProps<{
  class?: ClassValue
}>()

const isPopoverOpen = ref(false)

const { debugStore } = usePensionPortfolioDebug()

const { isAuthenticated, user } = useUser()
const login = useLogin()

const flowStageManager = usePensionFlowStageManager()
const { currentStage } = storeToRefs(flowStageManager)

const clipboard = useClipboard()

function copyUserDetails() {
  clipboard.copy(
    JSON.stringify(
      {
        id: user.value?.id,
        email: user.value?.email,
        accessToken: user.value?.accessToken,
      } as User,
      null,
      2
    )
  )
}
</script>

<style lang="scss" scoped></style>

<i18n lang="json">
{
  "he": {},
  "en": {}
}
</i18n>
